<template>
  <section>
    <div class="tab-wrap">
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '0' }" @click="changeListType" value="0">지급신청</button>
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '2' }" @click="changeListType" value="2">지급대기</button>
      <button type="button" class="tab-item" :class="{ active: reqData.creditStatus === '1' }" @click="changeListType" value="1">지급완료</button>
    </div>
    <div class="searchBar">
      <div class="box-ui-select searchbar-content">

        <div class="title"><span>신청날짜</span> :</div>
        <date-selector :class="'searchbar-content'" @setStartDate="setStartDate" @setEndDate="setEndDate" :startDefault="startDefault" :endDefault="endDefault" />
      </div>
      <div class="box-ui-select searchbar-content">
        <div class="title">
          <span>아이디</span> :
        </div>
        <input type="text" class="mr-5" v-model="reqData.siteId" :placeholder="'아이디'" />
        <button class="btn-search" type="button" @click="setTableData(1)">
          검색
        </button>
      </div>
    </div>
    <div class="main-contents-wrapper">
      <div class="table-wrapper">
        <table class="mainTable">
          <table-head :headInfo="headInfo" />
          <tbody v-if="applyList.length !== 0">
            <tr v-for="(item, idx) in applyList" :key="idx">
<!--              <template v-if="item.creditType === '1'">-->
                <td style="width: 10%">
                  <span><a href="#" class="userDetailOpen fc-id">{{ item.regId }}</a></span>
                </td>
                <td>{{ item.siteId }}</td>
                <td style="width: 10%">
                  <span>{{ item.creditIdx }}</span>
                </td>
                <td>
                  <span class="money-apply">{{ item.creditTypeText }}</span>
                </td>
                <td>
                  <span class="money-apply">{{ numberWithCommas(item.preCreditAmt) }}</span>
                </td>
                <td>
                  <span class="money-apply">{{numberWithCommas(item.realCreditAmt) }}</span>
                </td>
                <td>
                  <span class="money-apply">{{numberWithCommas(item.creditAmt) }}</span>
                </td>
                <td>{{ item.creditType === '3' ? 0 : Number(item.creditRate).toFixed(2) }}% </td>
                <td>{{ numberWithCommas((Number(item.realCreditAmt) * (Number(item.creditRate) * 0.01)).toFixed(0)) }}</td>
                <td>
                  <span>{{ numberWithCommas(Number(item.realCreditAmt) + Number(item.preCreditAmt)) }}</span>
                </td>
                <td style="width: 15%">
                  <span>{{ item.regDate }}</span>
                </td>
                <td style="width: 15%">
                  <span v-if="item.creditStatus === '1'">{{ item.updDate }}</span>
                  <span v-else>-</span>
                </td>
                <td class="statusColor" :class="item.statusClass">{{ item.statusText }}</td>
                <td style="width: 8%">
                  <div class="status-change-btn-wrap">
                    <button
                      class="btn-innerTable btn-status-change wait"
                      type="button"
                      v-if="item.creditStatus === '0'"
                      @click="statusChange(item.creditIdx, item.creditAmt, item.creditType, item.creditStatus)"
                    >
                      확인
                    </button>
                    <button
                      class="btn-innerTable btn-status-change refuse"
                      type="button"
                      value="1"
                      :data-list-idx="idx"
                      :data-cash-idx="item.cashIdx"
                      v-if="item.creditStatus === '2'"
                      @click="statusChange(item.creditIdx, item.creditAmt, item.creditType, item.creditStatus, 1)"
                    >
                      지급
                    </button>
                    <button
                      class="btn-innerTable btn-status-change refuse"
                      type="button"
                      value="1"
                      :data-list-idx="idx"
                      :data-cash-idx="item.cashIdx"
                      v-if="item.creditStatus === '2'"
                      @click="statusChange(item.creditIdx, item.creditAmt, item.creditType, item.creditStatus, -1)"
                    >
                      거절
                    </button>
                    <span v-if="item.creditStatus === '1'">-</span>
                    <!-- <button class="btn-innerTable btn-status-change warn" type="button" value="-1" :data-list-idx="idx" :data-cash-idx="item.cashIdx" v-if="item.creditStatus=='1'" @click="setCashStatus">회수</button> -->
                    <!-- <button class="btn-innerTable btn-status-change refuse" type="button" value="-1" :data-list-idx="idx" :data-cash-idx="item.cashIdx" v-if="item.creditStatus=='-1'" @click="setCashStatus">거절</button> -->
                  </div>
                </td>
<!--              </template>-->
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="14">
                <span class="notice-tableDataEmpty">데이터가 없습니다</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination v-if="applyList.length !== 0" @goPage="setTableData" :pageNum="pageInfo.page" :pageSize="pageInfo.count_per_list" :totalCount="pageInfo.tatal_list_count" />
  </section>
</template>

<script>
import SearchFilter from "@/components/common/SearchFilter";
import DateSelector from "@/components/common/DateSelector";
import TableHead from "@/components/main/table/Head.vue";
import { creditApplyList, creditUpdateStatus } from "@/api/credit.js";
import Pagination from "@/components/common/Pagination";
import UiCheck from "@/components/ui/UiCheckSet";
import {getDateStr, numberWithCommas} from "../../../../libs/utils";

export default {
  name: "CreditApplyList",
  components: {
    TableHead,
    DateSelector,
    SearchFilter,
    Pagination,
    UiCheck
  },
  props: {
    status: {
      type: String,
      default: "0"
    }
  },
  watch: {
    $route: {
      async handler() {
        const status = this.$route.params.status;
        console.log(status);
        this.setTableData(1, status);
      }
    }
  },
  data: function () {
    return {
      tableName: "Basic",
      headInfo: {
        fstColumn: false,
        dataList: ["companyId", "siteId", 'ptCode', 'state', 'prevPT', 'realPT', "applyAmt", "feeRate", "feeAmt", 'postPT', "applyDate", "updDate", "status", "statusChange"]
      },
      srchFiltersProp: {
        selectOptions: [
          {
            useAll: true,
            opts: [
              {
                title: "id"
              }
            ]
          }
        ]
      },
      reqData: {
        creditStatus: "0",
        creditType: "1",
        page: 1,
        count_per_list: "30"
      },
      pageInfo: {},
      applyList: [],
      checkList: [
        {
          val: "0",
          text: "요청"
        },
        {
          val: "1",
          text: "대기"
        },
        {
          val: "2",
          text: "완료"
        }
      ],
      startDefault: null,
      endDefault: null,
      dateConfigs: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      }
    };
  },
  methods: {
    setStartDate (date) {
      let _date = ''
      if (!date) {
        _date = new Date()
        _date.setHours(0, 0, 0)
      } else {
        _date = date[0]
      }
      this.startDefault = _date
      this.reqData.startDate = getDateStr(_date, 'yyyy-MM-dd HH:mm:ss')
    },
    setEndDate (date) {
      let _date = ''
      if (!date) {
        _date = new Date()
        _date.setHours(23, 59, 59)
      } else {
        _date = date[0]
        _date.setSeconds(59)
      }
      this.endDefault = _date
      this.reqData.endDate = getDateStr(_date, 'yyyy-MM-dd HH:mm:ss')
    },
    numberWithCommas,
    openWindow() {
      window.open("/user/userDetail", "userDetail", "top=0,left=150,scrollbars=no,resizable=no,width=1480,height=885,status=no");
    },
    async getCreditApplyList(pageNum) {
      if (pageNum) {
        this.reqData.page = pageNum;
      }
      const data = this.reqData;
      return await creditApplyList(data);
    },
    async changeListType(evt) {
      const target = evt.target;
      const chooseType = target.value;
      this.reqData.creditStatus = chooseType;
      this.setTableData(1);
    },
    async setTableData(pageNum, status) {
      if (status) {
        this.reqData.creditStatus = status;
      }
      const res = await this.getCreditApplyList(pageNum);
      const applyList = res.data.list;
      const pageInfo = res.data.pageInfo;
      if (pageInfo) {
        this.pageInfo = pageInfo;
      }
      this.applyList = this.dataConvertor(applyList);
    },
    creditPayment(dataObj) {
      const _creditAmt = prompt(`알 지급 금액`, dataObj.creditAmt);
      const trigger = {
        msg: "",
        prog: false
      };
      if (isNaN(_creditAmt)) {
        trigger.msg = "숫자만 입력해주세요.";
      } else if (_creditAmt <= 0) {
        trigger.msg = "지급 최소 금액은 0 이상 입니다. 다시 입력해주세요.";
      } else if (_creditAmt == null || _creditAmt == undefined) {
        trigger.msg = "";
      } else {
        trigger.msg = _creditAmt;
        trigger.prog = confirm(`${_creditAmt}을 지급합니다.`);
      }

      return trigger;
    },
    async statusChange(idx, creditAmt, type, status, nextStatus) {
      let reqData = {
        creditIdx: idx,
        creditType: type,
        creditStatus: status,
        creditAmt: creditAmt
      };
      switch (status) {
        case "0":
          reqData.creditStatus = "2";
          break;
        case "2":
          reqData.creditStatus = nextStatus.toString()
          break;
        case "1":
          (reqData.creditStatus = "1"), (reqData.creditType = "-1");
          reqData.creditAmt = "0";
          break;
      }
      let isConfirm = true
      if (reqData.creditStatus === '-1') {
        isConfirm = confirm('알지급을 거절하시겠습니까?')
      }
      if (isConfirm) {
        const res = await creditUpdateStatus(reqData);
        this.setTableData();
        if (res.resultCode === "0") {
          if (reqData.creditStatus === "1") {
            alert("알 지급 완료");
          } else {
            alert("알 상태 변경 완료");
          }
        } else {
          if (reqData.creditStatus === "1") {
            alert("알 지급에 실패 했습니다. 다시 시도해주세요.");
          } else {
            alert("알 상태 변경에 실패 했습니다. 다시 시도해주세요.");
          }
        }
      }
    },
    dataConvertor(dataList) {
      const _dataList = dataList;
      if (!dataList.length || dataList.length === 0) {
        return _dataList;
      }
      _dataList.forEach(items => {
        const creditStatus = items.creditStatus;
        let statusText = "";
        // - 0:요청, 1:완료, 2:대기 , -1"거부
        if (creditStatus === "0") {
          statusText = "지급신청";
          items.statusClass = "apply";
        } else if (creditStatus === "1") {
          statusText = "지급완료";
          items.statusClass = "approve";
        } else if (creditStatus === "2") {
          statusText = "지급대기";
          items.statusClass = "wait";
        } else if (creditStatus === "-1") {
          statusText = "지급거절";
          items.statusClass = "refuse";
        }
        if (!items.realCreditAmt) {
          items.realCreditAmt = "-";
        }

        switch (items.creditType) {
          case '1':
            items.creditTypeText = '지급신청'
            break
          case '-1':
            items.creditTypeText = '환급신청'
            break
          case '2':
            items.creditTypeText = '포인트전환'
            break
          case '3':
            items.creditTypeText = '포인트현금수령'
            break
          case '5':
            items.creditTypeText = '수동지급'
            break
          case '-5':
            items.creditTypeText = '수동회수'
            break
        }

        items.statusText = statusText;
        items.regDate = items.regDate.replace("T", " ");
        items.updDate = items.updDate.replace("T", " ");
        for (const item in items) {
          if (items[item] === "") {
            items[item] = "-";
          }
        }
      });
      return _dataList;
    }
  },
  async created() {
    this.setTableData();
  }
};
</script>

<style scoped>
.main-contents-wrapper {
  padding: 10px 0;
}
.statusColor {
  font-weight: 700;
}
.statusColor.apply {
  color: #ef8c1d;
}
.statusColor.approve {
  color: blue;
}
.statusColor.refuse {
  color: red;
}
.statusColor.wait {
  color: green;
}
</style>
